"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.url = exports.UrlGenerator = void 0;
const lodash_1 = __importDefault(require("lodash"));
const Services_1 = __importDefault(require("../../Services"));
const RouteTemplate_1 = require("./RouteTemplate");
class UrlGenerator {
    constructor(template, params) {
        this.params = params;
        this.templatePath = template;
    }
    getUrl() {
        return this.bindParams(this.params);
    }
    getFullUrl() {
        return Services_1.default.URL.createWithOrigin(this.getUrl());
    }
    bindParams(params) {
        if (lodash_1.default.isUndefined(this.template)) {
            throw Error('Template declared is Undefined...');
        }
        const countRouteParameter = (this.template.match(/\{\*\}/g) || []).length;
        if (countRouteParameter === 0) {
            return this.template;
        }
        let path;
        if (lodash_1.default.isArray(params)) {
            if (params.length !== countRouteParameter) {
                throw Error(`Missing required parameter for [Route: ${this.templatePath}] [URL: ${this.template}]`);
            }
            params.forEach((item) => {
                path = this.template.replace('{*}', item);
            });
            return path;
        }
        path = this.template.replace('{*}', params.toString());
        if (path.includes('{*}')) {
            throw Error(`Missing required parameter for [Route: ${this.templatePath}] [URL: ${path}]`);
        }
        return path;
    }
    getTemplate() {
        if (typeof this.templatePath === 'string') {
            const template_path = this.templatePath.split('.');
            let temp;
            if (template_path.length > 0) {
                template_path.forEach((item, index) => {
                    if (index === 0)
                        return temp = RouteTemplate_1.RouteTemplate[item];
                    temp = temp[item];
                });
            }
            this.template = temp;
        }
        return this;
    }
    make() {
        return this.getTemplate();
    }
}
exports.UrlGenerator = UrlGenerator;
function url(template, params = null) {
    return new UrlGenerator(template, params);
}
exports.url = url;
